module.exports = __webpack_public_path__ + "img/logo.e6cde6b1.png";